import { render, staticRenderFns } from "./GeofencingPage.vue?vue&type=template&id=0c5a8cc3&scoped=true&"
import script from "./GeofencingPage.vue?vue&type=script&lang=js&"
export * from "./GeofencingPage.vue?vue&type=script&lang=js&"
import style0 from "./GeofencingPage.vue?vue&type=style&index=0&id=0c5a8cc3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5a8cc3",
  null
  
)

export default component.exports